import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, Fragment as _Fragment } from "vue"
import _imports_0 from '../../assets/Images/icono-instector.png'
import _imports_1 from '../../assets/Images/icono-realtor.png'
import _imports_2 from '../../assets/Images/icono-titulo.png'
import _imports_3 from '../../assets/Images/logoRealtorToolsHeader2.png'


const _hoisted_1 = { class: "tw-flex tw-justify-between tw-items-center tw-bg-white tw-px-8 tw-py-5" }
const _hoisted_2 = { class: "tw-flex tw-items-center tw-p-0 tw-gap-3" }
const _hoisted_3 = {
  key: 0,
  class: "tw-h-[70px] tw-w-[70px]",
  src: _imports_0,
  alt: ""
}
const _hoisted_4 = {
  key: 1,
  class: "tw-h-[70px] tw-w-[70px]",
  src: _imports_1,
  alt: ""
}
const _hoisted_5 = {
  key: 2,
  class: "tw-h-[70px] tw-w-[70px]",
  src: _imports_2,
  alt: ""
}
const _hoisted_6 = {
  key: 3,
  class: "tw-h-[70px] tw-w-[70px]",
  src: _imports_0,
  alt: ""
}
const _hoisted_7 = { class: "tw-text-[#0080A3] tw-text-[40px] tw-font-normal tw-block" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "tw-w-[200px]" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: ""
  })
], -1)
const _hoisted_9 = { class: "d-flex align-items-center justify-content-between tw-pt-4 tw-px-4 tw-bg-[#E6E7E8]" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "content-dashboard__section-video__info-video ps-0" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-question-circle" }, null, -1)
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "d-flex align-items-center gap-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "table-mlo w-100 bg-white p-3 rounded-4 tw-text-center" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode(" If you have difficulty using it, add any criteria, or have any questions or topics, send us a message. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" We will respond to you as soon as possible.")
  ])
], -1)
const _hoisted_16 = {
  class: "textarea tw-mt-5 tw-w-full tw-flex tw-justify-center tw-items-center",
  style: {"border":"1px solid #e6e7e8"}
}
const _hoisted_17 = { class: "tw-flex tw-justify-end tw-items-center mt-3" }
const _hoisted_18 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BModal = _resolveComponent("BModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.userSession.role == 'Inspector' || _ctx.userSession.role == 'Realtor')
          ? (_openBlock(), _createElementBlock("img", _hoisted_3))
          : _createCommentVNode("", true),
        (_ctx.userSession.role == 'Admin')
          ? (_openBlock(), _createElementBlock("img", _hoisted_4))
          : _createCommentVNode("", true),
        (_ctx.userSession.role == 'Title Company')
          ? (_openBlock(), _createElementBlock("img", _hoisted_5))
          : _createCommentVNode("", true),
        (_ctx.userSession.role == 'MLO')
          ? (_openBlock(), _createElementBlock("img", _hoisted_6))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.userSession.role == "MORTGAGE LOAN ORIGINATOR" ? "" : _ctx.userSession.role), 1)
      ]),
      _hoisted_8
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_ctx.helpBar)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("span", null, _toDisplayString(_ctx.helpDescription), 1),
              _createVNode(_component_BModal, {
                buttonLabel: "WATCH VIDEO",
                videoID: "helpVideo"
              }, {
                default: _withCtx(() => [
                  (_ctx.helpVideo !== '')
                    ? (_openBlock(), _createElementBlock("video", {
                        key: 0,
                        id: "helpVideo",
                        src: _ctx.helpVideo,
                        class: "tw-w-full",
                        controls: ""
                      }, null, 8, _hoisted_13))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_14, [
        (_ctx.support)
          ? (_openBlock(), _createBlock(_component_BModal, {
              key: 0,
              name: "supportmd",
              buttonLabel: "SUPPORT",
              iconClass: "fas fa-user-cog tw-text-[#00A0DA]",
              altButton: true
            }, {
              default: _withCtx(() => [
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _withDirectives(_createElementVNode("textarea", {
                    name: "",
                    id: "",
                    cols: "53",
                    rows: "9",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.supportMessage.message) = $event)),
                    class: "py-3"
                  }, null, 512), [
                    [_vModelText, _ctx.supportMessage.message]
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.submitReport($event))),
                    disabled: !_ctx.supportMessage.message,
                    class: "tw-bg-[#78c18a] disabled:tw-bg-[#cfcfcf] disabled:tw-text-white tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl"
                  }, " SEND MESSAGE ", 8, _hoisted_18)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}